import {Empty} from 'antd';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import gfm from 'remark-gfm';

import ProductDisplayContent, {hasProductDisplayContent} from './display-content';

const Description = ({description, product, displayContent}) => {
  const hasLegacyDescription = !!String(description || '').trim();
  // Sản phẩm mã mới: API có thể không trả description cũ nhưng vẫn có size/giặt/... → không hiện Empty.
  const showEmpty = !hasLegacyDescription && !hasProductDisplayContent(product, displayContent);

  return (
    <div className='description'>
      <div className='title'>MÔ TẢ SẢN PHẨM</div>
      <div style={{margin: '20px 0'}}>
        {showEmpty && <Empty description='Sản phẩm chưa có mô tả chi tiết!' />}
        {!showEmpty && hasLegacyDescription && <ReactMarkdown remarkPlugins={[gfm]}>{description}</ReactMarkdown>}
      </div>
      <ProductDisplayContent product={product} displayContent={displayContent} />
    </div>
  );
};

export default Description;
